module.exports = __webpack_public_path__ + "img/male.cbe9c5e0.svg";